@if (!isSearch) {
  <div class="faq-body">
    @if (faqSection$ | async; as section) {
      <small>{{ section.faq.title }}</small>
      <h3>{{ section.title }}</h3>
      <!-- <p class="faq-body__subtitle">{{section.subtitle}}</p> -->
      <br />
      <br />
      @for (body of section.faqBodies; track body.id; let last = $last) {
        <p class="bigger bold">{{ body.title }}</p>
        <div
          class="faq-body__answer"
          [innerHTML]="body.body | safe: 'html'"></div>
        @if (!last) {
          <div class="divider"></div>
        }
      }
    } @else {
      <sharry-loading [fullscreen]="true"></sharry-loading>
    }
  </div>
}
